const TRANSLATION_CACHE_PREFIX = 'pambazuka_translate_';
const CACHE_EXPIRY_MS = 24 * 60 * 60 * 1000; // 24 hours

function getCachedTranslation(key) {
  try {
    const cached = localStorage.getItem(TRANSLATION_CACHE_PREFIX + key);
    if (cached) {
      const parsed = JSON.parse(cached);
      if (Date.now() - parsed.timestamp < CACHE_EXPIRY_MS) {
        return parsed.text;
      }
      localStorage.removeItem(TRANSLATION_CACHE_PREFIX + key);
    }
  } catch (e) { /* ignore */ }
  return null;
}

function setCachedTranslation(key, text) {
  try {
    localStorage.setItem(TRANSLATION_CACHE_PREFIX + key, JSON.stringify({
      text,
      timestamp: Date.now()
    }));
  } catch (e) { /* ignore storage full */ }
}

function makeCacheKey(text, targetLang) {
  const snippet = text.substring(0, 50).replace(/\s+/g, '_');
  return `${targetLang}_${snippet}_${text.length}`;
}

export async function translateText(text, targetLang, sourceLang = 'de') {
  if (!text || targetLang === 'de') return text;

  const cacheKey = makeCacheKey(text, targetLang);
  const cached = getCachedTranslation(cacheKey);
  if (cached) return cached;

  const apiKey = process.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY;
  if (!apiKey) {
    console.warn('Google Translate API key not configured');
    return text;
  }

  try {
    const response = await fetch(
      `https://translation.googleapis.com/language/translate/v2?key=${apiKey}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          q: text,
          source: sourceLang,
          target: targetLang === 'sw' ? 'sw' : targetLang,
          format: 'html'
        })
      }
    );
    const data = await response.json();
    if (data.data && data.data.translations && data.data.translations[0]) {
      const translated = data.data.translations[0].translatedText;
      setCachedTranslation(cacheKey, translated);
      return translated;
    }
    return text;
  } catch (error) {
    console.error('Translation error:', error);
    return text;
  }
}

export async function translateObject(obj, fields, targetLang, sourceLang = 'de') {
  if (targetLang === 'de' || !obj) return obj;

  const translated = { ...obj };
  const promises = fields.map(async (field) => {
    if (obj[field] && typeof obj[field] === 'string') {
      translated[field] = await translateText(obj[field], targetLang, sourceLang);
    }
  });
  await Promise.all(promises);
  return translated;
}
